"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newAttributeDisplayFormMetadataObject = exports.AttributeDisplayFormMetadataObjectBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2020 GoodData Corporation
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var factory_1 = require("./factory");
var builder_1 = require("../builder");
/**
 * Attribute display form metadata object builder
 * See {@link Builder}
 *
 * @beta
 */
var AttributeDisplayFormMetadataObjectBuilder = /** @class */ (function (_super) {
    tslib_1.__extends(AttributeDisplayFormMetadataObjectBuilder, _super);
    function AttributeDisplayFormMetadataObjectBuilder() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AttributeDisplayFormMetadataObjectBuilder.prototype.attribute = function (ref) {
        this.item.attribute = ref;
        return this;
    };
    AttributeDisplayFormMetadataObjectBuilder.prototype.displayFormType = function (type) {
        this.item.displayFormType = type;
        return this;
    };
    AttributeDisplayFormMetadataObjectBuilder.prototype.isDefault = function (value) {
        this.item.isDefault = value;
        return this;
    };
    return AttributeDisplayFormMetadataObjectBuilder;
}(factory_1.MetadataObjectBuilder));
exports.AttributeDisplayFormMetadataObjectBuilder = AttributeDisplayFormMetadataObjectBuilder;
/**
 * Attribute display form metadata object factory
 *
 * @param ref - attribute display form reference
 * @param modifications - attribute diplay form builder modifications to perform
 * @returns created attribute display form metadata object
 * @beta
 */
exports.newAttributeDisplayFormMetadataObject = function (ref, modifications) {
    if (modifications === void 0) { modifications = identity_1.default; }
    return builder_1.builderFactory(AttributeDisplayFormMetadataObjectBuilder, { type: "displayForm", ref: ref }, modifications);
};
//# sourceMappingURL=displayFormFactory.js.map